/**
 * Brand configuration for the web application.
 *
 * The brand name is the single source of truth for all user-facing branding.
 * It can be overridden at build time via the VITE_BRAND_NAME environment variable.
 */
export const BRAND_NAME = import.meta.env?.VITE_BRAND_NAME ?? 'Gharbatai Finance';
export const BRAND_SHORT_NAME = import.meta.env?.VITE_BRAND_SHORT_NAME ?? 'Gharbatai';
